// Do not modify this file by hand!
// Re-generate this file by running lit-localize

import { html } from "lit";
import { str } from "@lit/localize";

/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const templates = {
	"cooperation-preview-apartment": `Apartment · 50 m²`,
	"cooperation-preview-email-message": `The property owner is interested in selling and requested contact.`,
	"cooperation-preview-email-signature": `The Odhad Zdarma team`,
	"cooperation-preview-email-subject": `Apartment sale enquiry in Prague`,
	"cooperation-preview-example-email": `Example email`,
	"cooperation-preview-inbox": `Inbox`,
	"cooperation-preview-location": `Location`,
	"cooperation-preview-owner-contact": `Owner contact`,
	"cooperation-preview-owner-email": `owner@example.com`,
	"cooperation-preview-prague": `Na Chodovci 2544/34, Praha 4`,
	"cooperation-preview-property": `Property`,
	"cooperation-preview-property-sale": `Property sale`,
	"cooperation-preview-recipient": `To: agent@example.com`,
	"cooperation-preview-service": `Requested service`,
	h030e8d9ce95bcb8e: html`Commercial property<oz-divider></oz-divider>Apartment building`,
	h0647b8edea0051fb: html`Your browser settings do not allow to use all the features of this site properly. Please check your browser settings and try again. If you believe this site is not working properly, please contact us at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	h0f1b51cf616e6d5a: html`Form failed to send. If the issue persists contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	h12241244aea9ad45: html`Please support our project <a href="https://www.facebook.com/Odhad-zdarmacz-119682456094217/" target="_blank" rel="noopener noreferrer" class="no-wrap">odhad-zdarma.cz</a>`,
	h1ef89a8dee70b038: html`<b>Please enter full address</b> with the help of our autocomplete. <b>The system calculation considers exact location of property.</b>`,
	h1f98b56749739a02: html`You are not<br>committing to anything`,
	h1fbd7ba27ed07f76: html`Sorry, this is probably a technical error. If you want to submit the form without the SMS code, please continue by pressing the "<b>SEND</b>" button.`,
	h426dc724ba366dd4: html`Your property is according to the specified parameters too <span class="text-bold text-blue">atypical</span> because of:`,
	h4fa7b3ab1928c309: html`charged`,
	h59edcdcac17c477c: html`Addresses are temporarily unavailable. If the issue persists please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	h607488a3e7df7a69: html`Message failed to send. If the issue persists please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	h60bff28ac19068cf: html`After the consultation you can ask for elaboration of the valuation for the notary. You will be charged an amount starting from ${0}.`,
	h6c261046fb7c14d7: html`For free you get<br>professional estimate of rent amount`,
	h7580bcafb66c15e6: html`That's what our <a href="${0}">online calculator</a> is for.`,
	h7f8efeb521e0c55d: html`Market price of land designated <b>for commercial use and forest plots</b>determines on the basis of specific parameters, therefore it cannot be calculated online`,
	h8097db71119c0ee2: html`If you have not received the SMS code, click <a href="#" @click="${0}">here</a>.`,
	h855b5d3cd9bfad03: html`Algorithm of calculation <b>doesn't allow</b> in these cases to get a correct price estimate.`,
	h89504e0bc1f3886b: html`Inheritance proceedings<oz-divider></oz-divider>Settlement of co-owners`,
	h8cc9ff29142a42dc: html`Dated <b>${0}</b>`,
	h8ce11dd70cd3febe: html`free`,
	h907c66fd34cc34e3: html`I consent to the processing <a href="${0}" target="_blank">of my personal data</a>`,
	h981e459bf54f4991: html`Thank you, <b>Team OZ.</b>`,
	h99376b3aede5fbeb: html`It is only up to you, what you will do with our rent estimate.`,
	h9c7e5d4b39932a2e: html`E-mail failed to send. If the issue persists please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	ha82666f918e2de71: html`Locations are temporarily unavailable. If the issue persists please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	hb06e0b8b090d830d: html`The usable area includes everything <b>behind the entrance door</b>, but does not include balconies, loggias, terraces, cellars, gardens, etc.`,
	hb7853749a60d6e16: html`Initial<br>consultation`,
	hb7d22ab62616fba6: html`Form failed to load. If the issue persists please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	hc360a7c4d02c805b: html`Your property is according to the specified parameters too <span class="text-bold text-blue">atypical</span>.`,
	hcfb62527589cb66d: html`Valuation in the form required by the notary`,
	hd40c19fde1120149: html`Telephone estimate assessment is <b>for free.</b>`,
	hd87e525bed3a0e06: html`Your price estimate failed to load. In case of persistent problems, please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	hd88bca530147faef: html`<b>Please enter full address</b> with the help of our autocomplete.`,
	he8041cee1227bef1: html`If you have entered the wrong phone number, please use the <a id="back" href="#" @click="${0}"><oz-icon name="arrow" size="sm" direction="left"></oz-icon> <b>BACK</b></a> button.`,
	hea4c81ca68255acd: html`It is only up to you, what you will do with our estimate of market price.`,
	hf2b1c0abc9413f97: html`Failed to create the price tracking. If the issue persists please contact our support at <a href="mailto:info@odhad-zdarma.cz">info@odhad-zdarma.cz</a>. Thank you.`,
	hff74f1a831bac528: html`For free you get<br>professional assement of price`,
	s0324829f4761240f: `Market price estimate of your property`,
	s04a443962a30898d: `Land type`,
	s0588f5495577a1be: `This valuation is being processed by`,
	s068776162ee00fd7: `Age`,
	s06c99bea4f6bc06c: `After partial renovation`,
	s0d701d705baabc09: `Your parking`,
	s1097e948d686adbb: `Wooden house`,
	s127d918c6daa5c8a: `Result`,
	s135a6f3914f99e57: `Send to e-mail`,
	s1362b63b68454115: `Please choose one of these options.`,
	s13e74cfb6c8f2306: `Specialist-made valuation service is for property owners. You can use our online calculator for quick and free estimated rent amount.`,
	s158da3b04f082fbe: `You pay no commission and get free care for the duration of your tenancy`,
	s1609680216f5de71: `3+kk, 2 bedrooms, living room with kitchenette`,
	s16329aa4ae6ae39a: str`Reward ${0}+ VAT ${1}`,
	s16933e19b1368440: `Apartment`,
	s169480e9d76e8057: `Notary inheritance reward`,
	s1716825dfd16f0c1: `Cooperative`,
	s17a38aa7032d7d1c: `Looking for a rental`,
	s1a7a838e7e306a25: `Enter living area including basement, stairs and other areas in main building.`,
	s1bce92a7f6797fb5: `Choose property type`,
	s1c39e496ceadda42: `With us you will get the best mortgage conditions.`,
	s2052b259fb410d5c: `Once a day`,
	s2138547e0f27218d: `Property price`,
	s21ee5a794d7d736d: `Used`,
	s231e8c1804ca8c70: `5+1, 4 bedrooms, living room and kitchen`,
	s232faaf0acc2a547: `Electricity`,
	s23727d249414d1c6: str`Based on ${0} reviews`,
	s23e55e39793bc456: `Balcony size`,
	s242a37c0bc84137d: `NON-BINDING REQUEST`,
	s24ffa189baec2a9b: `Recreation / cottage`,
	s2716fab197974a0f: `Did you want to know the price immediately and without entering contact data?`,
	s27ad74e5f5f248a7: `Personal`,
	s27b16cc1376886bb: `FREE CONSULTATION`,
	s2906c56661857619: `Use`,
	s2b036b9432765258: `Telephone estimate assessment is for free.`,
	s2b5eeb32e1dd8333: `Connection possible within 10 meters`,
	s2bb3c51809a171eb: `4+1, 3 bedrooms, living room and kitchen`,
	s2c49b2364d1a7ab2: `Summary`,
	s2ebaff088cb60126: `Please fill out the code from SMS`,
	s2fd96c92a2e23417: `GO OVER TO SPECIALIST ESTIMATE`,
	s310fd272f593ed47: `Layout of your property`,
	s320770ae6a9f1e37: `GET AN OFFER`,
	s34b0d6f2902b1c90: `No connection to underground utilities`,
	s36021eceba848902: `You can have this property from:`,
	s36b450ae6a8ecfa5: `Enter total area of properties including built up areas.`,
	s3752d7cddd100d43: `Usable area`,
	s38cb11bd389e3b73: `FOR RENT WE RECOMMEND`,
	s39484ace4879b5d7: `Compare offers across the market.`,
	s39b231b0e8820a1b: `Unfortunately, we do not currently offer specialist valuations in your selected location. We recommend using one of the following options:`,
	s39ba12306c78e99e: `I'll let you handle it`,
	s39db4d0c8d9c3560: `Commercial property / Apartment building`,
	s39e5c64fbfb55c6c: `Specialist-made valuation service is for property owners. You can use our online calculator for quick and free property valuation.`,
	s39ef59a179c62dea: `Terrace house`,
	s39fe0e718ea54742: `Underground utilities`,
	s3af38262551c9f0e: `Construction - recreation`,
	s3cc93ee007e0a594: `Cancel the monitoring of the market price of this property`,
	s3d7f3e86772eed83: `Land plot number`,
	s3f8f537054f343c2: `After renovation`,
	s406d5a898eac2bb9: `Brick building / mixed construction`,
	s432732e4affb7886: `Available underground utilities`,
	s44c16dba858b1d5e: `Your estimate of the market price is:`,
	s4564b470fec2d32b: `Contact our specialist`,
	s458e3818183c8aec: `1+1, Bedroom and kitchen`,
	s47533d88642be6e4: `Outside parking slot`,
	s4b645189bc96576d: str`${0} year`,
	s4b6c02bc9b95f2ec: `SPECIFIC SPECIALIST.`,
	s4db783318312b279: `Like`,
	s4f11108a4f9d9c24: str`${0} years`,
	s4f5fa121ec70332d: `Inside parking slot`,
	s4fa821ab19297df3: `charged`,
	s50612fb2aca75eb2: `Parking`,
	s506a63acb9efb2f0: `What does the price include?`,
	s514c84efce4ff9cb: `Apartment, land`,
	s522b5f19b875fb9e: `The removal of the tracking was successful.`,
	s524c060eb0c424b8: `Last step and you're done!`,
	s537162953e0c78b1: `10 years`,
	s53b25de764f4d28a: `Specification of your property`,
	s5453f7df0dff6db2: `interest in your property`,
	s56612c6ed8d63f7b: `Tick this field to continue.`,
	s5697e2894a30e49b: `Prefabricated house`,
	s570a1618222f648e: `3+1, 2 bedrooms, living room and kitchen`,
	s57b85252ee6b3f75: `5 years`,
	s57b8637165708aba: `Your idea of amount of rent`,
	s57f9b387e39a7a4d: `Processing data`,
	s5bb6a5213ed9976d: `House type`,
	s5c27209629c5cd05: `Follow us`,
	s5d59f658d88ebb44: `For how long will you be repaying?`,
	s5e421798454f8101: `Mason house`,
	s5e52daa7182308f2: `WOULD YOU LIKE TO RECEIVE A NON-BINDING OFFER TO SELL YOUR LAND?`,
	s5e9ba0dac5428711: `GET THE BEST MORTGAGE ON THE MARKET`,
	s5ebaa4c6fa145299: `Equipment / furniture`,
	s5fa07c62e4e6a267: `ONLINE CALCULATOR`,
	s5fb2daf2936cafd8: `Request a free, non-binding consultation`,
	s5fe80856fdc094e3: `Land area`,
	s6093bf1827d5c0d1: `2+1, Bedroom, living room and kitchen`,
	s6293c623d9adc8a6: `Garage`,
	s643bca81041bd3a4: `Algorithm of calculation doesn't allow in these cases to get a correct price estimate. Please contact us, our real estate specialists will specify your price for free.`,
	s644a459740f5d895: `Cancel the tracking of the market rent of this property`,
	s648a2758d59b6316: `For demolition`,
	s666ea2942726703a: `including VAT`,
	s668080c6d2c3b25b: `New`,
	s66e7b60859777d2b: `Rent`,
	s6760e0aa8b4e6c96: `Once a month`,
	s6813b4d9d0e5c325: `SHOW PRICE`,
	s6822e806bd1c4efe: `Choose`,
	s68ebfcc5b0a9265f: `Semi-detached house`,
	s694e3bb3bf510392: `Garden`,
	s6a3f4b4679bad2b8: `Land`,
	s6aeb9157e6389672: `Sell / buy`,
	s6c3a0d724ee27a33: `The code received by SMS prevents your phone number from being used anonymously.`,
	s6c72ba7b32eb7cae: `done`,
	s6c96c4ea7895e0a6: `Location (district) of one of the properties`,
	s6cb2eff12e721143: `1+kk, Studio with kitchenette`,
	s6cea437ab985f348: `End row house`,
	s6fbd032c107dedcd: `VALUATION FOR INHERITANCE PROCEEDINGS`,
	s6fd54544ace68ab2: `Area of neighboring buildings`,
	s70955ad2e1b9afa5: `Your idea of price`,
	s724bc0ca5a3f4000: `Newly built`,
	s72a82c2da9c143f5: `Recalculate price to date`,
	s73352e5bc9496240: `Area`,
	s74273ffff3dd2bb9: `Other`,
	s745a959db02139aa: `Location of your property`,
	s76862fd02361d2af: `5+kk, 4 bedrooms, living room with kitchenette`,
	s78922a0c97580355: `Additional parts of your property`,
	s7a015ff9d162b85e: `Area of your property`,
	s7a5a18ef11ab4f8d: `Additional`,
	s7c6b57dc6463db44: `Free of charge and you will receive an offer within a few hours.`,
	s7d2c2a3ff7633e53: `Layout`,
	s7d80347773cd1d46: `You know the value of the market price, now you just need to sort out the financing.`,
	s80c0e5fb2bb2db64: `1 year`,
	s833ad955c7be5d91: `Your registration was successful! The API key has been sent to your email. Thank you for using our service.`,
	s83a522c591a88eec: `Automatic tracking of market rents`,
	s840b9e39124518be: `Full name`,
	s845a07205cdb5eba: `I am going to sell`,
	s85f082861e341e14: `Just curious`,
	s876c88b1e9cbac65: `NEXT`,
	s87d57f86a45b52e7: `SMS verification`,
	s88361f66b3956249: `Please fill out this field.`,
	s887115a559753d6b: `Automatic market price monitoring`,
	s89c612b1f735efeb: `Free of charge at the Cadastral Office`,
	s8a1fdedcebadbce9: `Attic`,
	s8a31812f0e2fb899: `PLEASE CONTACT US`,
	s8af026ea22f09a4b: `System maintenance is currently underway at our address provider. Service will be restored in a few minutes. We apologize for any inconvenience and thank you for your understanding.`,
	s8b7a689441f40fae: `The calculations are only indicative and are based on the offers of individual providers of mortgage products on the Czech market. The information provided on the website www.odhad-zdarma.cz is not an offer to conclude a contract, a promise to conclude a contract, an announcement of a public competition for the most suitable offer, a public offer, or any other legal action by the operator of this website, the company ODHAD ZDARMA s.r.o.`,
	s8ce11dd70cd3febe: `free`,
	s8ce294c799223dd6: `The price of the property must be higher than the value of own finances.`,
	s8de8e59df7825bbc: `Telephone or e-mail estimate is for free.`,
	s8e10847eebdd4ddb: `Property type`,
	s8e7258c871aaa410: `E-mail`,
	s8f27de18db0b4e44: `I have my own idea`,
	s902d651620626f7e: `Once every 3 months`,
	s929940bca62e78e2: `Estimate of market rent of your property`,
	s97277daa6cefd7c4: `Which locations would you like to receive leads from?`,
	s9778c9a00134e8be: `Is the property part of inheritance?`,
	s990ad3f93bad230e: `3 to 12 years`,
	s99310ca07f04892f: `Verification failed. Please check the box again and confirm you are not a robot.`,
	s9a53a9c0a7cd56c0: `Municipality`,
	s9b5f3f5b7d2af3ac: `The best rate available on the market`,
	s9ccbf69ff3b9e74b: `Before renovation`,
	s9deae5b1e7537073: `FOR SALE WE RECOMMEND`,
	s9e10753617cb2e47: `Annuity`,
	s9e4fcdc1de4defe6: `Number of garages`,
	s9e7496d6798495f0: `Bedroom, living room with kitchenette or smaller`,
	s9f489bcfc53849dc: `that will, however, not be enough for your notary.`,
	s9fe27712d8e788e6: `Stand-alone house`,
	sa003159aff410a96: `Sewer`,
	sa0faf0918003e1d1: `Leave contact details for a no-obligation consultation`,
	sa622c2aad74b6981: `Does not include fees`,
	sa8b4572ff30ad779: `Value of inherited property`,
	sa967ffa6b5a12313: `Area of living space`,
	sa98dd41ebcea8337: `Your message`,
	sa9cc83336b09a857: `SEND MESSAGE`,
	saa0a13d1bf69dc20: `Street and number`,
	saa2fde92f609ee01: `Once a week`,
	sab1114a5f102dedc: `Phone number`,
	sabaabffd84b0302a: `The interior condition of your property`,
	sad1dc8510af47729: `Your estimate of market rent is:`,
	saec95078c0dae180: `Sorry, we do not yet provide this service in this location.`,
	safdb55afe5260f64: `Balcony`,
	sb096731c1c1c7649: `Looking to rent`,
	sb0f12b49927d4772: `Personal finances`,
	sb1cda10b7375f6fc: str`${0} years`,
	sb275c907fcde35d9: `Water`,
	sb2df5dfa7992592b: `I need valuation for multiple properties`,
	sb3a514bfe36cd117: `Fixation`,
	sb3f918c1e43210e4: `Location`,
	sb4dc078c2e53b05b: `Company`,
	sb4f92497aab854bb: `The address was successfully located.`,
	sb53b7c335717c5e1: `With a mortgage amount of`,
	sb59eae2f965e4269: `Elevator`,
	sb5e2d2c3eb6bd003: `You will need a property valuation in a form required by notary.`,
	sb609273745cd4ff2: `Market rent estimate:`,
	sb726af9f61cb2c3a: `Price tracking has been created`,
	sb783d104b014ddf8: `Get a free consultation with a real estate agent`,
	sb7dbd5aeeec108ff: `Unfurnished`,
	sb91de4d098f91ef5: `You know the estimate price,`,
	sba6c3b0c2ea62755: `How often do you want to receive information about the current price?`,
	sbac13308bc77834e: `12 years and older`,
	sbbbe5796b915d947: `Please check the box to verify that you are not a robot.`,
	sbd5b470ee43b6500: `Terrace size`,
	sbe076142a2b38e06: `Furnished`,
	sbfb88c8151c73a64: `Building`,
	sc05e7fee44ae4431: `Number of spots`,
	sc0c7922c63766555: `Top floor`,
	sc0e3a3f849e0ccdd: `You can estimate your property's value for free using our online calculator.`,
	sc2fe43f7abbee84a: `Free bank estimate`,
	sc371a1630e289c5c: `40 years`,
	sc56fcc0fe4357491: `What kind of estimate do you need?`,
	sc593d7d279bb7d84: `Specification`,
	sc67e65e49aa96d13: `Terrace`,
	sc70feae6da359934: `Field / meadow`,
	sc9dcdb913e0126b4: `Your message has been sent successfully!`,
	scad4fb59dd9028fd: `We will prepare the necessary document for you. Contact us through the form below.`,
	sccbf4d19b55c986a: `Gas`,
	scdb5f1e3323631c2: `What do you want to use the API for?`,
	sce6021268db1fdf0: `As opposed to our online calculator this valuation is going to be processed by`,
	scee899610239574c: `Under 3 years`,
	scfb217b173c99111: `Other ways to get a property valuation`,
	scfb62527589cb66d: `Valuation in the form required by the notary`,
	scfd881bd5fc69f6c: `Form`,
	sd0444b709ed90ac1: `Estimation type`,
	sd0b5a0d705932207: `5 bedrooms, living room, kitchen or larger`,
	sd5edd1992226e4a3: `We cooperate with leading banks on the Czech market.`,
	sd6c3f170e1d83523: `CLOSE`,
	sd7573a7feeb12635: `For the estimate of the market price of the property without entering contact data please continue to our online calculator with button bellow.`,
	sdacf27a149d9515a: `Property`,
	sdc0148d6b987758d: `Enter the price`,
	sdc5a64b628e42a29: `Your e-mail has been sent`,
	sdc80e91f8c47fc02: `The summary could not be loaded. The calculation cannot be started.`,
	sdcac9e2e7e0711cd: `3 years`,
	sdd5161198f48b37b: `House`,
	sdd7cd3bc8ea7c7b3: `Why do we need your contact information for this service?`,
	sddec356a22ccdc70: `House (including plots)`,
	sde0338a86bc5c4f8: `I like the estimated price`,
	sdf390b72780691d1: `The code you entered is invalid. Please try again.`,
	sdf56ba99072809b8: `Price per month`,
	se2628da38f291550: `Cellar`,
	se33267d85cb8d226: `4+kk, 3 bedrooms, living room with kitchenette`,
	se3d500a9032083f3: `Once every 6 months`,
	se4079edfb703ef03: `Please enter correct e-mail address.`,
	se4b168c0141d0930: `Single room`,
	se9be6a87bfa5f913: `Garden size`,
	sea401374fdf0bf1d: `Construction - housing`,
	seade193612d7880c: `Online calculator`,
	seb53816217eef353: `/ month`,
	sec917b559f0da3ee: `Residential`,
	sed4c8152d7507f44: `Do you need a valuation to settle co-ownership or for inheritance proceedings? Continue by selecting the property type.`,
	sef2ff16d0455ce89: `BACK`,
	sf009500baf8efdf8: `2+kk, Bedroom, living room with kitchenette`,
	sf16ff90d80570c0a: `Ownership`,
	sf21f5d3f29264cff: `instant and free`,
	sf503270a665169a8: `More`,
	sf517f223347be9a4: `Calculation in progress`,
	sf51cb9c78c24ef5b: `SEND`,
	sf8a37f7b7ba79164: `Interior condition`,
	sf92e50b63d0f552c: `Connected to underground utilities`,
	sf9503844fc965373: `I am going to buy`,
	sfab75dfca3e988e7: `The final rental price may be affected by other features of the property – before renting, we recommend consulting the price with our partner, who you can contact via the form.`,
	sfcb7de5df3ea4a2e: `Inheritance proceedings`,
	sfd5fd8edd47b2278: `Enter area of neighboring buildings (for example: barns, workshops, single garages, farm buildings).`,
	sfdaae4c980f9b591: `What brings you here?`,
	sfe262cf296239dba: `Part of municipality`,
	sfeaf8f0e3057c875: `Floor`,
};
